import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { ContactBookContent } from './ContactBookPage';

export function ContactBookArchePage() {
  return (
    <ArcheLayout>
      <Routes>
        <Route path="/" element={<ContactBookContent />} />
      </Routes>
    </ArcheLayout>
  );
}
